import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {personalCompanySetupStatuses} from "constants/constants";

const PersonalCompanySetupStatusFilter = ({
    value,
    onChange,
    showLabel = true,
    showAllOption = true,
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false,
    ...props
}) => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            {showLabel && <h5>{"Şahıs Şirket Durumu"}</h5>}
            <SelectField
                showSearch
                value={value}
                data-testid="personal_company_setup_status"
                mode={mode}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option
                        key="all"
                        data-testid="personal_company_setup_status_all_option"
                        value="all"
                    >
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {personalCompanySetupStatuses.map(status => (
                    <SelectField.Option
                        key={status.value}
                        data-testid="personal_company_setup_status_option"
                        value={status.value}
                    >
                        {status.name}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default PersonalCompanySetupStatusFilter;
